// extracted by mini-css-extract-plugin
export default {"page":"layout_page__DyN6K","pageContainer":"layout_pageContainer__oMDV2"};